/**
 * Libellé lisible (admin / listes) : prénom + nom, sinon name/nom, sinon e-mail.
 * @param {Record<string, unknown>|null|undefined} p
 * @returns {string}
 */
export function profileDisplayName(p) {
  if (!p || typeof p !== "object") return "";
  const fn = String(p.first_name ?? "").trim();
  const ln = String(p.last_name ?? "").trim();
  const combined = [fn, ln].filter(Boolean).join(" ").trim();
  if (combined) return combined;
  const n = String(p.name ?? p.nom ?? "").trim();
  if (n) return n;
  return String(p.email ?? "").trim();
}
